import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 机构信息管理基础服务
 */
export class OrganizationBaseSvr {
    constructor() {
        this.baseurl = 'OrganizationBaseSvr.assx/';
    }

    /**
     * 跟据条件返回业主代表列表(只返回未删除的数据)
     * token:String, param:OwnerHeaderQueryPara, start:int, pageSize:int, detail:boolean, isPage:boolean
     */
    GetOwnerHeaderList(token, param, start, pageSize, detail, isPage){
        return request.post(this.baseurl + 'GetOwnerHeaderList', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString(), start:start, pageSize:pageSize, detail:detail, isPage:isPage }));
    }

    /**
     * 编辑居（村）民委员会
     * token:String, data:ResidentsCommittee
     */
    ModifyResidentsCommittee(token, data){
        return request.post(this.baseurl + 'ModifyResidentsCommittee', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 新建开发建设单位
     * token:String, data:BuildUnit
     */
    AddBuildUnit(token, data){
        return request.post(this.baseurl + 'AddBuildUnit', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 获取街道办事处（镇人民政府）
     * token:String, orgCode:String, detail:boolean
     */
    GetStreetOfficeDetail(token, orgCode, detail){
        return request.post(this.baseurl + 'GetStreetOfficeDetail', Qs.stringify({ token:token, orgCode:orgCode, detail:detail }));
    }

    /**
     * 获取业主代表成员列表(包含已删除的数据)
     * token:String, param:OwnerHeaderMemberQueryPara, start:int, pageSize:int, detail:boolean, isPage:boolean
     */
    GetAllOwnerHeaderMemberList(token, param, start, pageSize, detail, isPage){
        return request.post(this.baseurl + 'GetAllOwnerHeaderMemberList', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString(), start:start, pageSize:pageSize, detail:detail, isPage:isPage }));
    }

    /**
     * 获取业主代表
     * token:String, orgCode:String, detail:boolean
     */
    GetOwnerHeaderDetail(token, orgCode, detail){
        return request.post(this.baseurl + 'GetOwnerHeaderDetail', Qs.stringify({ token:token, orgCode:orgCode, detail:detail }));
    }

    /**
     * 获取业主代表成员列表(只返回未删除的数据)
     * token:String, param:OwnerHeaderMemberQueryPara, start:int, pageSize:int, detail:boolean, isPage:boolean
     */
    GetOwnerHeaderMemberList(token, param, start, pageSize, detail, isPage){
        return request.post(this.baseurl + 'GetOwnerHeaderMemberList', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString(), start:start, pageSize:pageSize, detail:detail, isPage:isPage }));
    }

    /**
     * 跟据条件返回业主委员会个数(只返回未删除的数据)
     * token:String, param:OwnerTeamQueryPara
     */
    GetOwnerTeamCount(token, param){
        return request.post(this.baseurl + 'GetOwnerTeamCount', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString() }));
    }

    /**
     * 获取业主代表成员根据机构代码
     * token:String, orgCode:String
     */
    GetOwnerHeaderMemberByOrgCode(token, orgCode){
        return request.post(this.baseurl + 'GetOwnerHeaderMemberByOrgCode', Qs.stringify({ token:token, orgCode:orgCode }));
    }

    /**
     * 新建业主委员会
     * token:String, data:OwnerTeam
     */
    AddOwnerTeam(token, data){
        return request.post(this.baseurl + 'AddOwnerTeam', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 获取业主代表成员
     * token:String, certificateNum:String
     */
    GetOwnerHeaderMember(token, certificateNum){
        return request.post(this.baseurl + 'GetOwnerHeaderMember', Qs.stringify({ token:token, certificateNum:certificateNum }));
    }

    /**
     * 删除业主代表
     * token:String, orgCode:String, isDel:boolean
     */
    DeleteOwnerHeader(token, orgCode, isDel){
        return request.post(this.baseurl + 'DeleteOwnerHeader', Qs.stringify({ token:token, orgCode:orgCode, isDel:isDel }));
    }

    /**
     * 添加业主代表成员
     * token:String, data:OwnerHeaderMember
     */
    AddOwnerHeaderMember(token, data){
        return request.post(this.baseurl + 'AddOwnerHeaderMember', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 编辑街道办事处（镇人民政府）
     * token:String, data:StreetOffice
     */
    ModifyStreetOffice(token, data){
        return request.post(this.baseurl + 'ModifyStreetOffice', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 跟据条件返回街道办事处（镇人民政府）个数(只返回未删除的数据)
     * token:String, param:StreetOfficeQueryPara
     */
    GetStreetOfficeCount(token, param){
        return request.post(this.baseurl + 'GetStreetOfficeCount', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString() }));
    }

    /**
     * 删除业主委员会
     * token:String, orgCode:String, isDel:boolean
     */
    DeleteOwnerTeam(token, orgCode, isDel){
        return request.post(this.baseurl + 'DeleteOwnerTeam', Qs.stringify({ token:token, orgCode:orgCode, isDel:isDel }));
    }

    /**
     * 删除物业服务企业
     * token:String, orgCode:String, isDel:boolean
     */
    DeleteRealtyMgeCom(token, orgCode, isDel){
        return request.post(this.baseurl + 'DeleteRealtyMgeCom', Qs.stringify({ token:token, orgCode:orgCode, isDel:isDel }));
    }

    /**
     * 跟据条件返回施工单位列表(返回所有数据，包含删除的删除的数据))
     * token:String, param:ConstructionQueryPara, start:int, pageSize:int, detail:boolean, isPage:boolean
     */
    GetAllConstructionList(token, param, start, pageSize, detail, isPage){
        return request.post(this.baseurl + 'GetAllConstructionList', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString(), start:start, pageSize:pageSize, detail:detail, isPage:isPage }));
    }

    /**
     * 跟据条件返回物业服务企业个数(返回所有数据，包含删除的删除的数据)
     * token:String, param:RealtyMgeComQueryPara
     */
    GetAllRealtyMgeComCount(token, param){
        return request.post(this.baseurl + 'GetAllRealtyMgeComCount', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString() }));
    }

    /**
     * 跟据条件返回开发建设单位个数(只返回未删除的数据)
     * token:String, param:BuildUnitQueryPara
     */
    GetBuildUnitCount(token, param){
        return request.post(this.baseurl + 'GetBuildUnitCount', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString() }));
    }

    /**
     * 编辑开发建设单位
     * token:String, data:BuildUnit
     */
    ModifyBuildUnit(token, data){
        return request.post(this.baseurl + 'ModifyBuildUnit', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 获取开发建设单位
     * token:String, orgCode:String, detail:boolean
     */
    GetBuildUnitDetail(token, orgCode, detail){
        return request.post(this.baseurl + 'GetBuildUnitDetail', Qs.stringify({ token:token, orgCode:orgCode, detail:detail }));
    }

    /**
     * 编辑业主代表
     * token:String, data:OwnerHeader
     */
    ModifyOwnerHeader(token, data){
        return request.post(this.baseurl + 'ModifyOwnerHeader', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 设置物业服务企业属性
     * token:String, data:RealtyMgeComProperty
     */
    SetRealtyMgeComProperty(token, data){
        return request.post(this.baseurl + 'SetRealtyMgeComProperty', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 跟据条件返回居（村）民委员会个数(返回所有数据，包含删除的删除的数据)
     * token:String, param:ResidentsCommitteeQueryPara
     */
    GetAllResidentsCommitteeCount(token, param){
        return request.post(this.baseurl + 'GetAllResidentsCommitteeCount', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString() }));
    }

    /**
     * 新建业主代表
     * token:String, data:OwnerHeader
     */
    AddOwnerHeader(token, data){
        return request.post(this.baseurl + 'AddOwnerHeader', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 新建施工单位
     * token:String, data:Construction
     */
    AddConstruction(token, data){
        return request.post(this.baseurl + 'AddConstruction', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 跟据条件返回审价单位列表(只返回未删除的数据)
     * token:String, param:AssessmentOrgQueryPara, start:int, pageSize:int, detail:boolean, isPage:boolean
     */
    GetAssessmentOrgList(token, param, start, pageSize, detail, isPage){
        return request.post(this.baseurl + 'GetAssessmentOrgList', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString(), start:start, pageSize:pageSize, detail:detail, isPage:isPage }));
    }

    /**
     * 跟据条件返回施工单位个数(只返回未删除的数据)
     * token:String, param:ConstructionQueryPara
     */
    GetConstructionCount(token, param){
        return request.post(this.baseurl + 'GetConstructionCount', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString() }));
    }

    /**
     * 删除居（村）民委员会
     * token:String, orgCode:String, isDel:boolean
     */
    DeleteResidentsCommittee(token, orgCode, isDel){
        return request.post(this.baseurl + 'DeleteResidentsCommittee', Qs.stringify({ token:token, orgCode:orgCode, isDel:isDel }));
    }

    /**
     * 跟据条件返回业主代表个数(返回所有数据，包含删除的删除的数据)
     * token:String, param:OwnerHeaderQueryPara
     */
    GetAllOwnerHeaderCount(token, param){
        return request.post(this.baseurl + 'GetAllOwnerHeaderCount', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString() }));
    }

    /**
     * 跟据条件返回物业服务企业列表(只返回未删除的数据)
     * token:String, param:RealtyMgeComQueryPara, start:int, pageSize:int, detail:boolean, isPage:boolean
     */
    GetRealtyMgeComList(token, param, start, pageSize, detail, isPage){
        return request.post(this.baseurl + 'GetRealtyMgeComList', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString(), start:start, pageSize:pageSize, detail:detail, isPage:isPage }));
    }

    /**
     * 跟据条件返回物业服务企业个数(只返回未删除的数据)
     * token:String, param:RealtyMgeComQueryPara
     */
    GetRealtyMgeComCount(token, param){
        return request.post(this.baseurl + 'GetRealtyMgeComCount', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString() }));
    }

    /**
     * 跟据条件返回业主委员会列表(返回所有数据，包含删除的删除的数据)
     * token:String, param:OwnerTeamQueryPara, start:int, pageSize:int, detail:boolean, isPage:boolean
     */
    GetAllOwnerTeamList(token, param, start, pageSize, detail, isPage){
        return request.post(this.baseurl + 'GetAllOwnerTeamList', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString(), start:start, pageSize:pageSize, detail:detail, isPage:isPage }));
    }

    /**
     * 删除开发建设单位
     * token:String, orgCode:String, isDel:boolean
     */
    DeleteBuildUnit(token, orgCode, isDel){
        return request.post(this.baseurl + 'DeleteBuildUnit', Qs.stringify({ token:token, orgCode:orgCode, isDel:isDel }));
    }

    /**
     * 跟据条件返回业主代表列表(返回所有数据，包含删除的删除的数据)
     * token:String, param:OwnerHeaderQueryPara, start:int, pageSize:int, detail:boolean, isPage:boolean
     */
    GetAllOwnerHeaderList(token, param, start, pageSize, detail, isPage){
        return request.post(this.baseurl + 'GetAllOwnerHeaderList', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString(), start:start, pageSize:pageSize, detail:detail, isPage:isPage }));
    }

    /**
     * 跟据条件返回开发建设单位个数(返回所有数据，包含删除的删除的数据)
     * token:String, param:BuildUnitQueryPara
     */
    GetAllBuildUnitCount(token, param){
        return request.post(this.baseurl + 'GetAllBuildUnitCount', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString() }));
    }

    /**
     * 跟据条件返回街道办事处（镇人民政府）个数(返回所有数据，包含删除的删除的数据)
     * token:String, param:StreetOfficeQueryPara
     */
    GetAllStreetOfficeCount(token, param){
        return request.post(this.baseurl + 'GetAllStreetOfficeCount', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString() }));
    }

    /**
     * 跟据条件返回审价单位个数(只返回未删除的数据)
     * token:String, param:AssessmentOrgQueryPara
     */
    GetAssessmentOrgCount(token, param){
        return request.post(this.baseurl + 'GetAssessmentOrgCount', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString() }));
    }

    /**
     * 跟据条件返回居（村）民委员会列表(只返回未删除的数据)
     * token:String, param:ResidentsCommitteeQueryPara, start:int, pageSize:int, detail:boolean, isPage:boolean
     */
    GetResidentsCommitteeList(token, param, start, pageSize, detail, isPage){
        return request.post(this.baseurl + 'GetResidentsCommitteeList', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString(), start:start, pageSize:pageSize, detail:detail, isPage:isPage }));
    }

    /**
     * 新建居（村）民委员会
     * token:String, data:ResidentsCommittee
     */
    AddResidentsCommittee(token, data){
        return request.post(this.baseurl + 'AddResidentsCommittee', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 获取审价单位
     * token:String, orgCode:String, detail:boolean
     */
    GetAssessmentOrgDetail(token, orgCode, detail){
        return request.post(this.baseurl + 'GetAssessmentOrgDetail', Qs.stringify({ token:token, orgCode:orgCode, detail:detail }));
    }

    /**
     * 获取物业企业列表
     * orgCode:String, relations:String, startIndex:int, maxSize:int
     */
    getRealtyMgeComListByParam(orgCode, relations, startIndex, maxSize){
        return request.post(this.baseurl + 'getRealtyMgeComListByParam', Qs.stringify({ orgCode:orgCode, relations:relations, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 跟据条件返回审价单位个数(返回所有数据，包含删除的删除的数据)
     * token:String, param:AssessmentOrgQueryPara
     */
    GetAllAssessmentOrgCount(token, param){
        return request.post(this.baseurl + 'GetAllAssessmentOrgCount', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString() }));
    }

    /**
     * 编辑审价单位
     * token:String, data:AssessmentOrg
     */
    ModifyAssessmentOrg(token, data){
        return request.post(this.baseurl + 'ModifyAssessmentOrg', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 删除街道办事处（镇人民政府）
     * token:String, orgCode:String, isDel:boolean
     */
    DeleteStreetOffice(token, orgCode, isDel){
        return request.post(this.baseurl + 'DeleteStreetOffice', Qs.stringify({ token:token, orgCode:orgCode, isDel:isDel }));
    }

    /**
     * 获取物业服务企业
     * token:String, orgCode:String, detail:boolean
     */
    GetRealtyMgeComDetail(token, orgCode, detail){
        return request.post(this.baseurl + 'GetRealtyMgeComDetail', Qs.stringify({ token:token, orgCode:orgCode, detail:detail }));
    }

    /**
     * 编辑物业服务企业
     * token:String, data:RealtyMgeCom
     */
    ModifyRealtyMgeCom(token, data){
        return request.post(this.baseurl + 'ModifyRealtyMgeCom', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 跟据条件返回业主委员会个数(返回所有数据，包含删除的删除的数据)
     * token:String, param:OwnerTeamQueryPara
     */
    GetAllOwnerTeamCount(token, param){
        return request.post(this.baseurl + 'GetAllOwnerTeamCount', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString() }));
    }

    /**
     * 跟据条件返回街道办事处（镇人民政府）列表(只返回未删除的数据)
     * token:String, param:StreetOfficeQueryPara, start:int, pageSize:int, detail:boolean, isPage:boolean
     */
    GetStreetOfficeList(token, param, start, pageSize, detail, isPage){
        return request.post(this.baseurl + 'GetStreetOfficeList', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString(), start:start, pageSize:pageSize, detail:detail, isPage:isPage }));
    }

    /**
     * 跟据条件返回开发建设单位列表(返回所有数据，包含删除的删除的数据)
     * token:String, param:BuildUnitQueryPara, start:int, pageSize:int, detail:boolean, isPage:boolean
     */
    GetAllBuildUnitList(token, param, start, pageSize, detail, isPage){
        return request.post(this.baseurl + 'GetAllBuildUnitList', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString(), start:start, pageSize:pageSize, detail:detail, isPage:isPage }));
    }

    /**
     * 获取居（村）民委员会
     * token:String, orgCode:String, detail:boolean
     */
    GetResidentsCommitteeDetail(token, orgCode, detail){
        return request.post(this.baseurl + 'GetResidentsCommitteeDetail', Qs.stringify({ token:token, orgCode:orgCode, detail:detail }));
    }

    /**
     * 跟据条件返回施工单位列表(只返回未删除的数据)
     * token:String, param:ConstructionQueryPara, start:int, pageSize:int, detail:boolean, isPage:boolean
     */
    GetConstructionList(token, param, start, pageSize, detail, isPage){
        return request.post(this.baseurl + 'GetConstructionList', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString(), start:start, pageSize:pageSize, detail:detail, isPage:isPage }));
    }

    /**
     * 跟据条件返回施工单位个数(返回所有数据，包含删除的删除的数据)
     * token:String, param:ConstructionQueryPara
     */
    GetAllConstructionCount(token, param){
        return request.post(this.baseurl + 'GetAllConstructionCount', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString() }));
    }

    /**
     * 获取业主委员会
     * token:String, orgCode:String, detail:boolean
     */
    GetOwnerTeamDetail(token, orgCode, detail){
        return request.post(this.baseurl + 'GetOwnerTeamDetail', Qs.stringify({ token:token, orgCode:orgCode, detail:detail }));
    }

    /**
     * 跟据条件返回物业服务企业列表(返回所有数据，包含删除的删除的数据)
     * token:String, param:RealtyMgeComQueryPara, start:int, pageSize:int, detail:boolean, isPage:boolean
     */
    GetAllRealtyMgeComList(token, param, start, pageSize, detail, isPage){
        return request.post(this.baseurl + 'GetAllRealtyMgeComList', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString(), start:start, pageSize:pageSize, detail:detail, isPage:isPage }));
    }

    /**
     * 跟据条件返回居（村）民委员会个数(只返回未删除的数据)
     * token:String, param:ResidentsCommitteeQueryPara
     */
    GetResidentsCommitteeCount(token, param){
        return request.post(this.baseurl + 'GetResidentsCommitteeCount', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString() }));
    }

    /**
     * 跟据条件返回开发建设单位列表(只返回未删除的数据)
     * token:String, param:BuildUnitQueryPara, start:int, pageSize:int, detail:boolean, isPage:boolean
     */
    GetBuildUnitList(token, param, start, pageSize, detail, isPage){
        return request.post(this.baseurl + 'GetBuildUnitList', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString(), start:start, pageSize:pageSize, detail:detail, isPage:isPage }));
    }

    /**
     * 跟据条件返回审价单位列表(返回所有数据，包含删除的删除的数据)
     * token:String, param:AssessmentOrgQueryPara, start:int, pageSize:int, detail:boolean, isPage:boolean
     */
    GetAllAssessmentOrgList(token, param, start, pageSize, detail, isPage){
        return request.post(this.baseurl + 'GetAllAssessmentOrgList', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString(), start:start, pageSize:pageSize, detail:detail, isPage:isPage }));
    }

    /**
     * 修改业主代表成员
     * token:String, data:OwnerHeaderMember
     */
    ModifyOwnerHeaderMember(token, data){
        return request.post(this.baseurl + 'ModifyOwnerHeaderMember', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 删除施工单位
     * token:String, orgCode:String, isDel:boolean
     */
    DeleteConstruction(token, orgCode, isDel){
        return request.post(this.baseurl + 'DeleteConstruction', Qs.stringify({ token:token, orgCode:orgCode, isDel:isDel }));
    }

    /**
     * 跟据条件返回街道办事处（镇人民政府）列表(返回所有数据，包含删除的删除的数据))
     * token:String, param:StreetOfficeQueryPara, start:int, pageSize:int, detail:boolean, isPage:boolean
     */
    GetAllStreetOfficeList(token, param, start, pageSize, detail, isPage){
        return request.post(this.baseurl + 'GetAllStreetOfficeList', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString(), start:start, pageSize:pageSize, detail:detail, isPage:isPage }));
    }

    /**
     * 获取业主代表成员个数(包含已删除的数据)
     * token:String, param:OwnerHeaderMemberQueryPara
     */
    GetAllOwnerHeaderMemberCount(token, param){
        return request.post(this.baseurl + 'GetAllOwnerHeaderMemberCount', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString() }));
    }

    /**
     * 获取物业服务企业属性
     * token:String, orgCode:String
     */
    GetRealtyMgeComProperty(token, orgCode){
        return request.post(this.baseurl + 'GetRealtyMgeComProperty', Qs.stringify({ token:token, orgCode:orgCode }));
    }

    /**
     * 获取施工单位
     * token:String, orgCode:String, detail:boolean
     */
    GetConstructionDetail(token, orgCode, detail){
        return request.post(this.baseurl + 'GetConstructionDetail', Qs.stringify({ token:token, orgCode:orgCode, detail:detail }));
    }

    /**
     * 编辑施工单位
     * token:String, data:Construction
     */
    ModifyConstruction(token, data){
        return request.post(this.baseurl + 'ModifyConstruction', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 新建物业服务企业
     * token:String, data:RealtyMgeCom
     */
    AddRealtyMgeCom(token, data){
        return request.post(this.baseurl + 'AddRealtyMgeCom', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 跟据条件返回业主代表个数(只返回未删除的数据)
     * token:String, param:OwnerHeaderQueryPara
     */
    GetOwnerHeaderCount(token, param){
        return request.post(this.baseurl + 'GetOwnerHeaderCount', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString() }));
    }

    /**
     * 新建审价单位
     * token:String, data:AssessmentOrg
     */
    AddAssessmentOrg(token, data){
        return request.post(this.baseurl + 'AddAssessmentOrg', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 删除审价单位
     * token:String, orgCode:String, isDel:boolean
     */
    DeleteAssessmentOrg(token, orgCode, isDel){
        return request.post(this.baseurl + 'DeleteAssessmentOrg', Qs.stringify({ token:token, orgCode:orgCode, isDel:isDel }));
    }

    /**
     * 跟据条件返回居（村）民委员会列表(返回所有数据，包含删除的删除的数据))
     * token:String, param:ResidentsCommitteeQueryPara, start:int, pageSize:int, detail:boolean, isPage:boolean
     */
    GetAllResidentsCommitteeList(token, param, start, pageSize, detail, isPage){
        return request.post(this.baseurl + 'GetAllResidentsCommitteeList', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString(), start:start, pageSize:pageSize, detail:detail, isPage:isPage }));
    }

    /**
     * 跟据条件返回业主委员会列表(只返回未删除的数据)
     * token:String, param:OwnerTeamQueryPara, start:int, pageSize:int, detail:boolean, isPage:boolean
     */
    GetOwnerTeamList(token, param, start, pageSize, detail, isPage){
        return request.post(this.baseurl + 'GetOwnerTeamList', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString(), start:start, pageSize:pageSize, detail:detail, isPage:isPage }));
    }

    /**
     * 新建街道办事处（镇人民政府）
     * token:String, data:StreetOffice
     */
    AddStreetOffice(token, data){
        return request.post(this.baseurl + 'AddStreetOffice', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 获取业主代表成员个数(只返回未删除的数据)
     * token:String, param:OwnerHeaderMemberQueryPara
     */
    GetOwnerHeaderMemberCount(token, param){
        return request.post(this.baseurl + 'GetOwnerHeaderMemberCount', Qs.stringify({ token:token, param:typeof param === 'undefined' || param === null ? '' : param.toString() }));
    }

    /**
     * 删除业主代表成员
     * token:String, certificateNum:String
     */
    DeleteOwnerHeaderMember(token, certificateNum){
        return request.post(this.baseurl + 'DeleteOwnerHeaderMember', Qs.stringify({ token:token, certificateNum:certificateNum }));
    }

    /**
     * 设置业主代表成员状态
     * token:String, certificateNum:String, status:int
     */
    SetOwnerHeaderMemberStatus(token, certificateNum, status){
        return request.post(this.baseurl + 'SetOwnerHeaderMemberStatus', Qs.stringify({ token:token, certificateNum:certificateNum, status:status }));
    }

    /**
     * 编辑业主委员会
     * token:String, data:OwnerTeam
     */
    ModifyOwnerTeam(token, data){
        return request.post(this.baseurl + 'ModifyOwnerTeam', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }
}